import Footer from 'ui/snippets/footer/Footer';

import Container from './Container';
import Content from './Content';
import MainArea from './MainArea';
import MainColumn from './MainColumn';
import SideBar from './SideBar';

export {
  Container,
  Content,
  MainArea,
  SideBar,
  MainColumn,
  Footer,
};

// Container
//    MainArea
//       SideBar
//       MainColumn
//          Content
//    Footer
